export default __webpack_public_path__ + "static/media/homeBannerBgTbl.db64ed8f.png";